import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ValidationService } from '../../common/services';
import { ButtonAction, ButtonType } from '../action-button/constants';
import { mustNotBeBlankValidator } from '../../common/utils';
import { ExportFileFacade } from '../../common/models';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ExportType } from '../../store';
import { IconNames } from '../../common';

@Component({
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportDialogComponent implements OnInit {
  exportDialogForm: UntypedFormGroup;
  buttonAction = ButtonAction;
  buttonType = ButtonType;
  navigationNeeded = false;
  reportTypeOptions = [ExportType.TrackAndTrace, ExportType.DeliveryPerformance];
  iconNames = IconNames;

  constructor(
    public validationService: ValidationService,
    public dialogRef: MatDialogRef<ExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isReportLimitationExceeded: boolean;
      reportLimitRows: number;
      facade: ExportFileFacade;
      addressExport?: string;
      hasReportType?: boolean;
    },
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  confirm(navigationNeeded: boolean): void {
    const { reportName, reportType } = this.exportDialogForm.value;
    const clearReportName = reportName.trim();
    if (this.data.addressExport) {
      return this.data.facade.startExportToFile(
        clearReportName,
        this.dialogRef,
        navigationNeeded,
        this.data.addressExport,
        reportType,
      );
    }
    return this.data.facade.startExportToFile(clearReportName, this.dialogRef, navigationNeeded, null, reportType);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  get hasReportType(): boolean {
    return this.data.hasReportType;
  }

  private initForm(): void {
    if (this.hasReportType) {
      this.exportDialogForm = this.fb.group({
        reportName: ['', [Validators.required, mustNotBeBlankValidator]],
        reportType: [ExportType.TrackAndTrace, [Validators.required]],
      });
    } else {
      this.exportDialogForm = this.fb.group({
        reportName: ['', [Validators.required, mustNotBeBlankValidator]],
      });
    }
  }
}
